"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FutureBillsResponseMapper = void 0;
var FutureBillsResponseMapper = /** @class */ (function () {
    function FutureBillsResponseMapper(data) {
        this.localData = data;
    }
    FutureBillsResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return FutureBillsResponseMapper;
}());
exports.FutureBillsResponseMapper = FutureBillsResponseMapper;
//# sourceMappingURL=FutureBillsResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/FutureBillsResponseMapper.js
// module id = 2059
// module chunks = 8